import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { InputLabel } from "@material-ui/core";

import { selectHeatMapMetric } from "../../store/heatmap/HeatMapSelectors";
import { setHeatMapMetric } from "../../store/heatmap/HeatMapActions";
import { setPrefetchPauseUntil } from "../../store/product-list/ProductListActions";
import {
  StyledConfigSection,
  StyledHeatMapFormControl,
  StyledHeatMapSelect,
} from "./HeatMapModalStyles";
import { HEAT_MAP_METRICS } from "../../utils/HeatMapUtils";

/** Helper: true if the metric requires analytics data for a given range. */
export const isHeatMapMetricDateReliant = (metric: string): boolean =>
  HEAT_MAP_METRICS.find((m) => m.value === metric)?.dateReliant ?? false;

const HeatMapMetricSelect: React.FC = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const metric = useSelector(selectHeatMapMetric);
  const labelId = "heatmap-metric-label";

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    dispatch(setPrefetchPauseUntil(Date.now() + 500));
    dispatch(setHeatMapMetric(event.target.value as string));
  };

  const labelText = intl.formatMessage({
    id: "heatMap.metricLabel",
    defaultMessage: "Select Metric",
  });

  return (
    <StyledConfigSection>
      <StyledHeatMapFormControl size="small" variant="outlined">
        <InputLabel id={labelId}>{labelText}</InputLabel>
        <StyledHeatMapSelect
          native
          variant="outlined"
          labelId={labelId}
          label={labelText}
          value={metric}
          onChange={handleChange}
          inputProps={{ "aria-label": "Heat Map Metric" }}
        >
          {HEAT_MAP_METRICS.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </StyledHeatMapSelect>
      </StyledHeatMapFormControl>
    </StyledConfigSection>
  );
};

export default HeatMapMetricSelect;
